import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Card, CardBody, CardHeader, CardText } from "reactstrap";
import MetaTags from "react-meta-tags";
import document from "assets/images/document.png"
import compound from "assets/images/totalCompound.png"
import unit from "assets/images/totalUnit.png"
import "./styles.scss"
import DashboardService from "services/Provider/DashboardService"
import Transactions from "./transactions";
 import { SuccessOk } from "configs/statusCode";
 
import { providerPrefix } from "configs/routePrefix"
import { useDispatch } from "react-redux";
import { appendFilters } from "store/adminFilter/actions";

 
const cardsTypes = ["leadsCard", "dealsCard", "appointmentsCard", 
                "activitiesCard", "sales_rep_calls", 
                "sales_rep_calls_today", "sales_rep_meetings", 
                "sales_rep_meetings_today", "delayed_deals",
              "today_scheduled_appointments", "leads_interested_to_buy",
            "leads_interested_to_sell", "crm_activities_appointments_today"]
 
const SalesRepDashBoard = (props) => {
  const dashboardService = new DashboardService()
  const [dashboardData, setDashboardData] = useState(null)
  const dispatch = useDispatch()

    useEffect(()=>{
        dispatch(appendFilters({developer_id: null}))
    },[])
 
 
  useEffect(() => {
    cardsTypes.map(item => {
      let data = {
        [`${item}`]: 1
      }
      dashboardService.getList(data).then((res) => {
        if (res && res.status === SuccessOk) {
          setDashboardData(data => ({
            ...data,
            ...res.data
          }))
        }
      })
    })
  }, []);

  return (
    <React.Fragment>
      <div className='account-pages my-5 pt-5'>
        <MetaTags>
          <title>Dashboard</title>
        </MetaTags>
        <Container className="px-lg-3">
          <Row>
            <Col lg='12'>
              <div className=''>
                <h4>Dashboard</h4>
                <p>From here, you can see all the quick numbers</p>
                <Row>
                  <Col lg={4} sm={6}>
                    <Card className="shadow">
                      <CardBody className="d-flex justify-content-between pb-2 pt-3">
                        <div>
                          <h5 
                          onClick={()=>props.history.push("/sales-rep/leads")}
                          className="text-muted fw-bold btn-hover">Total Leads</h5>
                          <h4>{dashboardData ?.leadsCard}</h4>
                        </div>
                        <img src={document} height="50px" alt="" />
                      </CardBody>
                    </Card>
                  </Col>
                  <Col lg={4} sm={6}>
                    <Card className="shadow">
                      <CardBody className="d-flex justify-content-between pb-2 pt-3">
                        <div>
                          <h5 
                            onClick={()=>props.history.push("/sales-rep/deals")}
                          className="text-muted fw-bold btn-hover">Total Deals</h5>
                          <h4>{dashboardData ?.dealsCard}</h4>
                        </div>
                        <img src={compound} height="50px" alt="" />
                      </CardBody>
                    </Card>
                  </Col>
                  <Col lg={4} sm={6}>
                    <Card className="shadow">
                      <CardBody className="d-flex justify-content-between pb-2 pt-3">
                        <div>
                          <h5 
                           onClick={()=>props.history.push("/sales-rep/appoinments")}
                          className="text-muted fw-bold btn-hover">Total Appointment</h5>
                          <h4>{dashboardData ?.appointmentsCard}</h4>
                        </div>
                        <img src={unit} height="50px" alt="" />
                      </CardBody>
                    </Card>
                  </Col>

                  <Col lg={4} sm={6}>
                    <Card className="shadow">
                      <CardBody className="d-flex justify-content-between pb-2 pt-3">
                        <div>
                          <h5
                            className="text-muted fw-bold">Calls Made Today</h5>
                          <h4>{dashboardData ?.sales_rep_calls_today}</h4>
                        </div>
                        {/* <img src={unit} height="50px" alt="" /> */}
                        <i className="icon fa fa-phone"></i>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col lg={4} sm={6}>
                    <Card className="shadow">
                      <CardBody className="d-flex justify-content-between pb-2 pt-3">
                        <div>
                          <h5 className="text-muted fw-bold w-75">Calls Made </h5>
                          <h4>{dashboardData ?.sales_rep_calls}</h4>
                        </div>
                        <i className="icon fa fa-phone"></i>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col lg={4} sm={6}>
                    <Card className="shadow">
                      <CardBody className="d-flex justify-content-between pb-2 pt-3">
                        <div>
                          <h5 className="text-muted fw-bold">Meetings Made Today</h5>
                          <h4>{dashboardData ?.sales_rep_meetings_today}</h4>
                        </div>
                        <i className="icon fa fa-users"></i>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col lg={4} sm={6}>
                    <Card className="shadow">
                      <CardBody className="d-flex justify-content-between pb-2 pt-3">
                        <div>
                          <h5 className="text-muted fw-bold">Meetings Made</h5>
                          <h4>{dashboardData ?.sales_rep_meetings}</h4>
                        </div>
                        <i className="icon fa fa-users"></i>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col lg={4} sm={6}>
                    <Card className="shadow">
                      <CardBody className="d-flex justify-content-between pb-2 pt-3">
                        <div>
                          <h5 className="text-muted fw-bold">Delayed Deals</h5>
                          <h4>{dashboardData ?.delayed_deals}</h4>
                        </div>
                        <i className="fa icon fa-handshake"></i>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col lg={4} sm={6}>
                    <Card className="shadow">
                      <CardBody className="d-flex justify-content-between pb-2 pt-3">
                        <div>
                          <h5 className="text-muted fw-bold">Today Scheduled <br></br>Appointments</h5>
                          <h4>{dashboardData ?.today_scheduled_appointments}</h4>
                        </div>
                        <i className="icon fa fa-list"></i>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col lg={4} sm={6}>
                    <Card className="shadow">
                      <CardBody className="d-flex justify-content-between pb-2 pt-3">
                        <div>
                          <h5 className="text-muted fw-bold">Leads <span>Interested to Buy</span></h5>
                          <h4>{dashboardData ?.leads_interested_to_buy}</h4>
                        </div>
                        <img src={compound} height="50px" alt="" />
                      </CardBody>
                    </Card>
                  </Col>
                  <Col lg={4} sm={6}>
                    <Card className="shadow">
                      <CardBody className="d-flex justify-content-between pb-2 pt-3">
                        <div>
                          <h5 className="text-muted fw-bold">leads <span>Interested to Sell</span></h5>
                          <h4>{dashboardData ?.leads_interested_to_sell}</h4>
                        </div>
                        <img src={document} height="50px" alt="" />
                      </CardBody>
                    </Card>
                  </Col>
                  <Col lg={4} sm={6}>
                    <Card className="shadow">
                      <CardBody className="d-flex justify-content-between pb-2 pt-3">
                        <div>
                          <h5 className="text-muted fw-bold">CRM Activities Today</h5>
                          <h4>{dashboardData ?.crm_activities_appointments_today}</h4>
                        </div>
                        <i className="icon fa fa-list"></i>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          <Row className="pb-5">
            <Col lg={8}>
              <Transactions appointment={dashboardData ?.appointmentsCard}/>
            </Col>
            <Col lg={4}>
              <Card style={{minHeight:"91.8vh"}}>
                <CardBody className="maxHeightAll">
                  <CardText tag="h5" className="pb-2">
                    Activity <span className="font-size-15 float-end text-primary">
                    {dashboardData ?.activitiesCard ?.length===4 ?<span className="btn-hover" onClick={()=>{
                        props.history.push(`${providerPrefix}/activities`)
                      }} >See All</span>:null}
                    </span>
                  </CardText>
                  {dashboardData ?.activitiesCard ?.length ? dashboardData.activitiesCard.map((activity, index) => {
                   if(index<4){
                    return (
                      <div className="border p-3" key={index}>
                         <CardText tag="p" className="text-muted mb-2">{activity.formatted_dob}</CardText>
                        <CardText tag="p" className="text-muted">
                          {activity.title}  
                        </CardText>
                      </div>
                    )
                   }
                  })
                    : null
                  }
                  {/* <div className="border p-3">
                    <CardText tag="h6" className="font-font-size-18">Akram Magdy <span className="badge bg-light font-size-12 text-success">Admin</span></CardText>
                    <CardText tag="p" className="text-muted mb-2">12 Mar, 2020</CardText>
                    <CardText tag="p" className="text-muted">
                      Added a new compound <span className="fw-bold text-decoration-underline text-dark">Prime Avenu</span>
                    </CardText>
                  </div> */}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default SalesRepDashBoard;
